export const TICK_HZ = 60;
export const TICK_MS = 1000 / TICK_HZ;
const MAX_TICKS_PER_FRAME = 4;

/** Fixed 60 Hz update, rendering on every animation frame. Drops time instead of spiralling when too slow. */
export function startFixedLoop(update: () => void, render: () => void, isRunning: () => boolean, ticksPerTick: () => number = () => 1): void {
  let last = performance.now();
  let acc = 0;
  const frame = (now: number) => {
    acc += Math.min(now - last, 250);
    last = now;
    if (!isRunning()) acc = 0;
    let n = 0;
    while (acc >= TICK_MS && n < MAX_TICKS_PER_FRAME) {
      for (let i = ticksPerTick(); i > 0; i--) update();
      acc -= TICK_MS;
      n++;
    }
    if (n === MAX_TICKS_PER_FRAME) acc = 0;
    render();
    requestAnimationFrame(frame);
  };
  requestAnimationFrame(frame);
}
